module.exports = __webpack_public_path__ + "static/media/Mix_inicio_testigo2_opinion.787005ff.png";